



























import { defineComponent, SetupContext, ref, computed, onMounted, watch, Ref } from '@vue/composition-api'
import useD3Module from '../composables/useD3Module'
import useObserverResize from '../composables/useObserverResize'
import { ComponentProps } from '@bpchart/types/vueComponent'
// import { Size } from '@bpchart/types'

// 以防嵌入的 d3-module 本身沒有 width/height屬性，所以給一個預設值
const defaultWidth = 800
const defaultheight = 500

export default defineComponent({
  props: {
    module: {},
    params: {},
    data: {},
    datum: {},
    dataset: {},
    filter: {},
    width: {
      default: () => 0
    },
    height: {
      default: () => 0
    },
    forceFit: {
      default: () => true
    },
    zoom: {},
  },
  emits: ['click', 'mouseover', 'mousemove', 'mouseout', 'dragStart', 'drag', 'dragEnd', 'zoom'],
  setup (props: ComponentProps, context: SetupContext) {
    const container = ref(null)
    const svg = ref(null)
    // 如 props無 width/height 則預設為 0（渲染時才取）
    // const containerWidth: Ref<string> = ref(typeof props.width === 'string' ? props.width : `${props.width}px`)
    // const containerHeight: Ref<string> = ref(typeof props.height === 'string' ? props.height : `${props.height}px`)
    const containerWidth = computed(() => {
      if (props.forceFit) {
        return '100%'
      } else if (container.value && (container.value as any).clientWidth == 0) {
        return `${d3Module.value.width || defaultWidth}px`
      } else {
        return typeof props.width === 'string' ? props.width : `${props.width}px`
      }
    })
    const containerHeight = computed(() => {
      if (container.value && (container.value as any).clientHeight == 0) {
        return `${d3Module.value.height || defaultheight}px`
      } else {
        return typeof props.height === 'string' ? props.height : `${props.height}px`
      }
    })
    const svgWidth: Ref<number> = ref(0)
    const svgHeight: Ref<number> = ref(0)

    const { d3Module, createModule, eventHandler, debounceRender } = useD3Module({
      D3Module: props.module,
      props,
      context,
    })

    watch(props, () => {
      debounceRender()
    })
    
    onMounted(() => {
      createModule(svg.value!)
      eventHandler((eventName, data) => {
        context.emit(eventName, data)
      })

      // // container尺寸
      // if (props.forceFit) {
      //   containerWidth.value = '100%'
      // } else if ((container.value as any).clientWidth == 0) {
      //   containerWidth.value = `${d3Module.value.width || defaultWidth}px`
      // }
      // if ((container.value as any).clientHeight == 0) {
      //   containerHeight.value = `${d3Module.value.height || defaultheight}px`
      // }
      
      setTimeout(() => {
        // svg尺寸
        svgWidth.value = (container.value as any).clientWidth
        svgHeight.value = (container.value as any).clientHeight
        
        if (props.forceFit) {
          // 監聽 container的 dom尺寸
          const contentRect = useObserverResize(container.value!)
          watch(contentRect, () => {
            svgWidth.value = contentRect.value!.width
            svgHeight.value = contentRect.value!.height
            d3Module.value.resize && d3Module.value.resize({ width: svgWidth.value, height: svgHeight.value })
            debounceRender()
          })
        } else {
          debounceRender()
        }

        watch(props, () => debounceRender())
      })
      
    })

    return {
      d3Module,
      container,
      svg,
      containerWidth,
      containerHeight,
      svgWidth,
      svgHeight
    }
  }
})
